import React from 'react';
import { useDispatch } from 'react-redux';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import bookmark from '../../../../Assets/images/bookmark.svg';
import classes from './saveButton.module.scss';
import { loginRequest } from '../../../../authConfig';

export default function SaveButton(props) {
  const { id, isSaved, saveDispatcher, unsaveDispatcher, isLarge = false } = props;
  const { instance } = useMsal();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const isProfileCompleted = localStorage.getItem('userProfileCompleted') === 'true';
  const userId = localStorage.getItem('UserId');
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const saveHandler = () => {
    if (isAuthenticated) {
      if (isProfileCompleted) {
        dispatch(isSaved ? unsaveDispatcher(id) : saveDispatcher(id, userId));
      } else {
        localStorage.setItem('saveJobAfterCompleteProfile', JSON.stringify(id));
        navigate('/dashboard/profile-builder-one');
      }
    } else {
      localStorage.setItem('saveJobAfterLogin', JSON.stringify(id));
      instance
        .loginRedirect({
          ...loginRequest,
          redirectUri: `${window.location.origin}/dashboard/jobs`,
          state: JSON.stringify({ navigate: `/dashboard/jobs/${id}` })
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  return (
    <button className={`${classes.saveButton} ${isLarge ? classes.large : ''}`} onClick={saveHandler}>
      {isSaved ? t('common.general.unsave') : t('common.general.save')}
      <img className={classes.icon} src={bookmark} alt="save" />
    </button>
  );
}
